<template>
  <div class="">
    <template v-if="isRepairerInternalRfqChat">
      <div style="margin-right: 35px">
        <button v-if="!isShowInternalChat" :class="{ active: btnPositionScroll && isShowOnBottom }"
                @click="openInternalChat" type="button"
                class="btn waves-effect waves-light d-flex align-items-center btn-chat btn-chat-internal">
          <span>{{ headerChatName }}</span>
          <i
              class="bx bx-message-rounded-dots"
              style="font-size: 20px; line-height: 2px; padding-left: 7px; position: relative; right: 0;"
          ></i></button>

        <button v-else
                :class="{ active: btnPositionScroll && isShowOnBottom }" type="button"
                @click="isShowInternalChat = false; $emit('closeInternalChat')"
                class="btn btn-primary waves-effect waves-light d-flex align-items-center btn-scroll-bottom btn-chat-come internal-chat"
                style="box-shadow: none; margin-right: 15px; background-color: #29BBC1;">
          In Chat
          <i
              class="bx bx-message-rounded-dots"
              style="font-size: 20px; line-height: 2px; padding-left: 7px; color: #1c1f39; position: relative; right: -21px;"
          ></i></button>
      </div>
    </template>
    <template v-else-if="isRepairerRfqChat">
      <button v-if="!isShowChat && !isShowUnViewedMessages"
              :class="{ active: btnPositionScroll && isShowOnBottom }"
              @click="openChat"
              type="button"
              class="btn waves-effect waves-light d-flex align-items-center btn-chat">
        <span>{{ headerChatName }}</span>
        <i
            class="bx bx-message-rounded-dots"
            style="font-size: 20px; line-height: 2px; padding-left: 7px;"
        ></i></button>

      <button v-else-if="!isShowChat && isShowUnViewedMessages"
              :class="{ active: btnPositionScroll && isShowOnBottom }"
              @click="openChat" type="button"
              class="btn waves-effect waves-light d-flex align-items-center btn-blink_new-message btn-scroll-bottom btn-chat">
        <span style="color: #79B1BB;" :class="{'new-msg-supplier': isUserTypeSupplier}">New Msg</span>
        <i
            class="bx bx-message-rounded-dots"
            style="font-size: 20px; line-height: 2px; padding-left: 7px; position: relative; right: 0;"
        ></i></button>

      <button :class="{ active: btnPositionScroll && isShowOnBottom, 'internal-chat': isInternalChat }" v-else
              type="button" @click="isShowChat = false; $emit('closeChat')"
              class="btn btn-primary waves-effect waves-light d-flex align-items-center btn-scroll-bottom btn-chat-come"
              style="box-shadow: none; margin-right: 15px; background-color: #29BBC1;">
        In Chat
        <i
            class="bx bx-message-rounded-dots"
            style="font-size: 20px; line-height: 2px; padding-left: 7px; color: #1c1f39; position: relative; right: -20px;"
        ></i></button>
    </template>

    <div v-if="isShowInternalChat" class="window-chat" style="right: 0"
         :class="{ active: windowChatPosition && isShowOnBottom }"
    >
      <div class="window-chat-header">
        <div class="d-flex justify-content-between" style="height: 50px; flex-direction: column;">
          <div class="window-chat-company_name">{{ userName }}</div>
          <span
              style="cursor: pointer;font-size: 32px; opacity: 0.5; color: #000000; position: absolute; right: 10px; top: -5px"
              @click="isShowInternalChat = false">×</span>
          <div class="window-chat-status online mb-0-25" v-if="isChatterOnline">Online</div>
          <div class="window-chat-status mb-0-25" v-else>Offline</div>
        </div>
        <!--        <div class="window-chat-username">Test Testovich</div>-->
      </div>
      <div class="window-chat-body" ref="windowChatBody">
        <chat-message
            v-for="(message, i) in messages"
            :key="i"
            :senderName="message.senderName"
            :message="message">
          <div v-if="getDate(message.createdOn, message.id)" class="window-chat-body-date">
            {{ formatDate(message.createdOn) }}
          </div>
        </chat-message>
      </div>
      <div style="width: 100%; padding: 5px 5px 0 5px">
          <span class="text-typing" :class="{ hidden: !typersText }">
          {{ typersText }}
            <span class="typing">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </span>
          </span>
      </div>
      <div class="" style="position: relative">
        <highlightable-input
            ref="highlightableInput"
            v-model="messageText"
            :isShowListMentionedUsers="true"
            :mentionUsers="mentionUsers"
            :class="{ 'list-users-padding-left': isShowInternalChat }"
            :isShowSendIcon="true"
            :isForChat="true"
            @onHighlight="v =>handleHighlight(v)"
            @onSelectUser="selectUser"
            @onSubmitMessage="m=>onChatMessageSubmit(m)"
            @onIconClick="onChatMessageSubmit"
            @input="onChatInputKeydown"
            style="min-height: 44px; max-height: 100px; height: auto; overflow: auto; padding: 0; width: 346px; margin: 5px 0"
            class="form-control chat-msg-input"
        />
        <!--        <textarea type="text"-->
        <!--                  class="form-control"-->
        <!--                  placeholder="Write a message..."-->
        <!--                  ref="chatInput"-->
        <!--                  v-model="messageText"-->
        <!--                  style="min-height: 42px; resize: none;"-->
        <!--                  :disabled="!inputEnabled"-->
        <!--                  @keydown.enter="onChatMessageSubmit"-->
        <!--        />-->
      </div>
    </div>

    <div v-if="isShowChat"
         :class="{ active: windowChatPosition && isShowOnBottom }"
         class="window-chat">
      <div class="window-chat-header">
        <div class="d-flex justify-content-between position-relative" style="height: 50px; flex-direction: column;">
          <multiselect
              :options="userNames"
              v-model="userName"
              track-by="value"
              label="value"
              :showLabels="false"
              :option-height="29"
              :max-height="203"
              :close-on-select="true"
              class="multiselect-user-name"
          />
          <div v-if="dropDownMenu" class="window-chat-company_name-selection">
            <ul>
              <li>
                <span>All</span>
              </li>
              <li>
                <span>John SMitch</span>
              </li>
            </ul>
          </div>
          <span
              style="cursor: pointer;font-size: 32px; opacity: 0.5; color: #000000; position: absolute; right: -10px; top: -15px"
              @click="isShowChat = false">×</span>
          <div class="window-chat-status online mb-0-25" v-if="isChatterOnline">Online</div>
          <div class="window-chat-status mb-0-25" v-else>Offline</div>
        </div>
        <!--        <div class="window-chat-username">Test Testovich</div>-->
      </div>
      <div class="window-chat-body" ref="windowChatBody">
        <chat-message
            v-for="(message, i) in messages"
            :key="i"
            :message="message"
            :senderName="message.companyName+' - ' + message.senderName"
        >
          <div v-if="getDate(message.createdOn, message.messageId)"
               class="window-chat-body-date">
            {{ formatDate(message.createdOn) }}
          </div>
        </chat-message>
      </div>
      <div style="width: 100%; padding: 5px 5px 0 5px">
          <span class="text-typing" :class="{ hidden: !typersText }">
          {{ typersText }}
            <span class="typing">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </span>
          </span>
      </div>
      <div class="" style="position: relative">
        <highlightable-input
            class="form-control chat-msg-input"
            style="height: 44px; overflow: auto; padding: 0px; width: 346px"
            @onHighlight="v =>handleHighlight(v)"
            @onEnter="onChatMessageSubmit"
            v-model="messageText"
            @onIconClick="onChatMessageSubmit"
            :isShowSendIcon="true"
            ref="highlightableInput"
            @input="onChatInputKeydown"
        />
        <!--        <textarea type="text"-->
        <!--                  class="form-control"-->
        <!--                  placeholder="Write a message..."-->
        <!--                  ref="chatInput"-->
        <!--                  v-model="messageText"-->
        <!--                  style="min-height: 42px; resize: none;"-->
        <!--                  :disabled="!inputEnabled"-->
        <!--                  @keydown.enter="onChatMessageSubmit"-->
        <!--        />-->
      </div>
    </div>
  </div>

</template>

<script>
import * as dayjs from 'dayjs'
import ChatMessage from './chat-message'
import HighlightableInput from '../../../components/HighlightableInput'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import Axios from 'axios'

export default {
  name: 'ChatNew',
  components: {
    Multiselect,
    ChatMessage,
    HighlightableInput
  },
  props: {
    objectId: 0,
    objectType: {
      type: String | null,
      default: '',
    },
    chatType: {
      type: String | null,
      default: '',
    },
    headerChatName: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
    userInternalName: {
      type: String,
      default: '',
    },
    isShowChatInit: {
      type: Boolean,
      default: false
    },
    isChatterOnline: {
      type: Boolean,
      default: false
    },
    isShowOnBottom: {
      type: Boolean,
      default: true
    },
    isInternalChat: {
      type: Boolean,
      default: false
    },

  },
  data () {
    return {
      userNames: [
        { value: 'All', },
        { value: 'John Smitt', },
        { value: 'Second Test Supplier OEM-GEN', },
      ],
      typers: [
        // { name: 'John Smitt', microtime: 1757227093 },
        // { name: 'Vera Nears', microtime: 1757227093 },
        // { name: 'Vuldrs', microtime: 1757227093 },
        // { name: 'Joseph Mirgo', microtime: 1757227093 },
        // { name: 'Leruande smith', microtime: 1757227093 },
      ],
      forUsers: [],
      dropDownMenu: false,
      lastChatInputMicrotime: 0,
      usedDate: {},
      messageText: '',
      inputEnabled: true,
      isShowChat: false,
      isShowInternalChat: false,
      isHighlight: false,
      scrollPosition: 0,
      btnPositionToScroll: false,
      microtime: Date.now(),
    }
  },
  watch: {
    messages: {
      handler () {
        this.scrollToBottom()
      },
      immediate: true
    },
  },
  mounted () {
    if (!this.isInternalChat) {
      this.isShowChat = this.isShowChatInit
    }else{
      this.isShowInternalChat = this.isShowChatInit
    }
    window.addEventListener('scroll', () => {
      this.scrollPosition = window.scrollY
    })
  },
  created () {
    this.$nextTick(() => {
      this.microtimeInterval = setInterval(() => {
        this.microtime = Date.now()
      }, 100)
    })
  },
  beforeDestroy () {
    clearInterval(this.microtimeInterval)
  },
  computed: {
    ...mapGetters({
      'currentUser': 'currentUser/getCurrentUserInfo',
      'currentCompany': 'currentCompany/getDetails',
      isUserTypeSupplier: 'currentUser/isUserTypeSupplier',
      isUserTypeRepairer: 'currentUser/isUserTypeRepairer',
      isMultipleLocations: 'settings/isMultipleLocations',
      getterSettings: 'settings/getSettings',
      mentionUsers: 'chats/getMentionUsers',
      currentUserId: 'currentUser/getId',
    }),
    isRepairerInternalRfqChat(){
      return (this.chatType === 'InternalRfqMsg' && this.isUserTypeRepairer)
    },
    isRepairerRfqChat(){
      return (this.chatType === 'RfqMsg' && this.isUserTypeRepairer)
    },
    messages () {
      let messages = this.$store.getters['chats/getAllInternalRfqMessage']
      return _.filter(messages, (msg) => {
        return Number(msg.objectId) === Number(this.objectId)
      })
    },
    typersText () {
      const names = []
      for (const [key, value] of Object.entries(this.typers)) {
        if (true || this.microtime - value.microtime < 1500) {
          names.push(value.name)
        }
      }
      if (names.length === 0) {
        return this.microtime === 0
      }
      if (names.length === 1) {
        return names[0] + ' is typing'
      }
      return names.join(', ') + ' are typing'
    },
    isShowUnViewedMessages () {
      return _.some(this.messages, (m) => {
        if (this.isUserTypeSupplier && this.isMultipleLocations) {
          return !m.viewed && !_.find(this.getterSettings.multipleBrands, (b) => {
            return Number(m.companyId) === Number(b.id)
          })
        }
        return !m.viewed && Number(m.companyId) !== Number(this.currentCompany.id)
      })
    },
    btnPositionScroll () {
      if (this.scrollPosition > 50) {
        return this.btnPositionToScroll = true
      } else {
        return this.btnPositionToScroll = false
      }
    },
    windowChatPosition () {
      return this.scrollPosition > 50
    }
  },
  methods: {
    selectUser (user) {
      console.log('Select user:', user)
      if (this.messageText) {
        this.messageText = this.messageText + ' '
      }
      if (user && user.hasOwnProperty('gid')) {
        this.messageText = this.messageText + '<mark class="mention" data-gid="' + user.gid + '">' + user.name + '</mark> '
      } else if (user && user.hasOwnProperty('uid')) {
        this.messageText = this.messageText + '<mark class="mention" data-uid="' + user.uid + '">' + user.name + '</mark> '
      }
      this.$refs.highlightableInput.focus()
    },
    formatDate (v) {
      if (dayjs(v).isToday()) {
        return 'Today'
      }
      return dayjs(v).format('DD/MM/YYYY')
    },
    getDate (date, id) {
      let d1 = dayjs(date).format('YYYY-MM-DD')
      // console.log('getDate',date,id,d1)
      if (!this.usedDate[d1] && this.usedDate[d1] != id) {
        this.usedDate[d1] = id
        return date
      }
      if (this.usedDate[d1] == id) {
        return date
      }
      return false
    },
    isHasDifference (ind) {
      return true
      if (this.messages.length = 1) {
        return true
      }

      if (!this.messages[ind] || !this.messages[ind - 1]) {
        return false
      }

      let date1 = dayjs(this.messages[ind].createdOn)
      console.log(date1.diff(this.messages[ind - 1].createdOn, 'day', true), 'diff')
      return date1.diff(this.messages[ind - 1].createdOn, 'day', true) == 1
    },
    handleHighlight (isHighlight) {
      this.isHighlight = isHighlight
    },
    _isEmpty (v) {
      return _.isEmpty(v)
    },
    openChat () {
      this.isShowChat = true
      this.scrollToBottom()
    },
    openInternalChat () {
      this.isShowInternalChat = true
    },
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    scrollToBottom () {
      this.$nextTick(() => {
        let el = this.$refs.windowChatBody
        if (el) {
          el.scrollTo(0, el.scrollHeight)
        }
      })
    },
    onChatMessageSubmit (m) {
      // console.log('onChatMessageSubmit', m)
      if (m) {
        this.inputEnabled = false
        Axios.post('/centrifuge/repairer/send-message', {
          objectId: Number(this.objectId),
          objectType: this.objectType,
          chatType: this.chatType,
          message: m.trim(),
        }).then((r) => {
          if (r && r.data?._status) {
            this.messageText = ''
            this.forUsers = []
          }
        }).finally(() => {
          this.inputEnabled = true
          setTimeout(() => {
            this.$refs.highlightableInput.focus()
          }, 200)
        })
      }
    },
    onChatInputKeydown () {
      if (!this.messageText.trim()) {
        return
      }
      const microtime = Date.now()
      if (microtime - this.lastChatInputMicrotime > 300) {
        this.$emit('onTyping')
        this.lastChatInputMicrotime = microtime
      }
    }
  }
}
</script>

<style>
.chat-msg-input .text-input {
  height: auto !important;
  min-height: 42px !important;
  padding: 0.375rem 40px 0.375rem 0.75rem !important;
}

.chat-msg-input.list-users-padding-left .text-input {
  padding: 0.375rem 40px 0.375rem 40px !important;
}

.chat-msg-input .has-error-highlightable-input {
  height: auto !important;
  min-height: 42px !important;
  padding: 0.375rem 40px 22px 40px !important;
}

.chat-msg-input .text-danger {
  position: absolute !important;
  background: white !important;
  bottom: 0px !important;
}
</style>
<style scoped>
.multiselect-user-name {
  width: auto;
  max-width: 85%;
}

.multiselect-user-name {
  display: flex;
}

.multiselect-user-name.multiselect--active >>> .multiselect__tags {
  width: auto;
}

.multiselect-user-name >>> .multiselect__option--highlight {
  color: #0ca8b2;
}

.multiselect-user-name >>> .multiselect__content-wrapper {
  width: auto;
  top: 32px;
}

.multiselect-user-name >>> .multiselect__select {
  position: relative;
}

.multiselect-user-name >>> .multiselect__tags {
  border: none;
  padding-left: 0;
  order: -1;
  padding-right: 10px;
}

.multiselect-user-name >>> .multiselect__tags .multiselect__single {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  position: relative;
  bottom: 4px;
  color: #1C1F39;
}

.window-chat-company_name-selection {
  position: absolute;
  border: 2px solid #a5a5a5;
  top: 30px;
  background-color: white;
  min-width: 200px;
  border-radius: 3px;
}

.window-chat-company_name-selection ul {
  padding: 0;
  margin: 0;
  font-size: 13px;
  font-weight: bold;
}

.window-chat-company_name-selection ul li {
  list-style-type: none;
  padding: 5px 10px;
  border: 0;
}

.window-chat-company_name-selection ul li:hover {
  border: none;
  color: #09a7b1;
  background-color: #ceeeef;
}

.window-chat-company_name-repairer .bx-chevron-down {
  font-size: 22px;
  position: relative;
  font-weight: 700;
  top: 4px;
  margin-left: 5px;
}

.window-chat-company_name-repairer .bx-chevron-up {
  transform: rotate(360deg)
}

.internal-chat {
  min-width: 141px;
  justify-content: center;
}

.hidden {
  display: none !important;
}

.text-typing {
  font-size: 13px;
  color: grey;
  font-weight: bold;
}

.typing {
  align-items: center;
  height: 15px;
  padding-left: 3px;
}

.typing .dot {
  animation: mercuryTypingAnimation 1.8s infinite ease-in-out;
  background-color: rgba(20, 178, 185, .7);
  border-radius: 50%;
  height: 7px;
  margin-right: 4px;
  vertical-align: middle;
  width: 7px;
  display: inline-block;
}

.typing .dot:nth-child(1) {
  animation-delay: 200ms;
}

.typing .dot:nth-child(2) {
  animation-delay: 300ms;
}

.typing .dot:nth-child(3) {
  animation-delay: 400ms;
}

.typing .dot:last-child {
  margin-right: 0;
}

@keyframes mercuryTypingAnimation {
  0% {
    transform: translateY(0px);
    //background-color:rgba(20, 178, 185,.7);
  }
  28% {
    transform: translateY(-7px);
    //background-color:rgba(20, 178, 185,.4);
  }
  44% {
    transform: translateY(0px);
    //background-color:rgba(20, 178, 185,.2);
  }
}

.btn-chat {
  position: static;
  top: auto;
  box-shadow: none;
  color: rgb(28, 31, 57);
  background-color: white;
  margin-right: 15px;
  border-color: rgb(41, 187, 193);
  font-weight: bold;
  z-index: 10;
}

.btn-chat.active {
  position: fixed;
  bottom: 5px;
  right: 0;
  top: auto;
  z-index: 99999;
  box-shadow: none;
  margin-right: 15px;
}
.btn-chat-come{
  min-width: 141px;
  justify-content: center;
}
.btn-chat-come.active {
  position: fixed;
  bottom: 5px;
  right: 0;
  top: auto;
  z-index: 99999;
  box-shadow: none;
  margin-right: 15px;
}
.btn-chat.active.internal-chat{
  right: 0;
}
.btn-chat-come.active.internal-chat{
  right: 0;
}
.btn-chat-internal.btn-chat.active{
  right: 0;
}
.new-msg-supplier {
  color: #29bbc1 !important;
}

.window-chat {
  position: absolute;
  display: flex;
  flex-direction: column;
  height: 600px;
  width: 350px;
  border: 2px solid var(--supplier-color);
  border-radius: 5px;
  background-color: rgb(229, 245, 246);
  z-index: 1009;
  right: 11px;
  transition: all 0.2s ease-in-out;
  top: 190px;
}

.window-chat.active {
  position: fixed;
  bottom: 46px;
  top: auto;
  transition: all 0.2s ease-in-out;
  z-index: 10009;
}


.window-chat-header {
  background-color: #fdfdfd;
  padding: 10px 20px;
}

.window-chat-company_name {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  margin-bottom: 10px;
}

.window-chat-company_name-repairer {
  cursor: pointer;
}

.window-chat-username {
  font-size: 14px;
  letter-spacing: 0;
  line-height: 24px;
}

.window-chat-status {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  margin-bottom: 15px;
  color: #9D0025;
}

.window-chat-status.online {
  color: #36bec3;
}

.window-chat-body {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 15px;
}

.window-chat-body-date {
  border-top: 1px solid #a5a5a5;
  width: 100%;
  font-size: 11px;
  text-align: center;
  padding: 3px 0;
  align-items: center;
}


@keyframes soft-blink {
  0%, 100% {
    background-color: white
  }
  50% {
    background-color: #36bec3
  }
}

.btn-blink_new-message {
  -webkit-animation: soft-blink 2s linear infinite;
  -moz-animation: soft-blink 2s linear infinite;
  -ms-animation: soft-blink 2s linear infinite;
  -o-animation: soft-blink 2s linear infinite;
  animation: soft-blink 2s linear infinite;
}
</style>
